import { COLORS } from 'app/constants'
import BigNumber from 'bignumber.js'
import React from 'react'
import { Text } from 'styles/reactnative'
import { useExchangeList } from '../../hooks/trade/exchangeList'

const Price = ({ ep_id = undefined, price = 0, dp = undefined }: any) => {
	const { data: EPs } = useExchangeList()
	const EP = EPs?.find(ep => ep?.id === ep_id)

	return (
		<Text
			style={{
				justifyContent: 'flex-end',
			}}>
			{dp != undefined
				? BigNumber(price).toFormat(dp)
				: BigNumber(price).toFormat(EP?.dp || 3)}
		</Text>
	)
}

export default React.memo(Price)
